import React from 'react';

// @ts-ignore
import Snow from './holiday-snow';

interface IProps {
  snow?:any;
  colorTheme?:any;
}

class HolidayUi extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public componentDidMount = () =>{
    if(this.props.colorTheme){
      this.setupTheme()
    }
  }

  public setupTheme = ()=>{
    if (typeof document !== 'undefined') {
      if(document.body){
        document.body.className += ' holiday-theme';

        //Frosty footer
        let footerElem = document.createElement('div');
        footerElem.setAttribute('class',"frosty-footer");
        document.body.appendChild(footerElem);

        //Frosty header mobile
        let mobileHeaderElem = document.createElement('div');
        mobileHeaderElem.setAttribute('class',"holiday-ice");
        let headerMobile = document.getElementsByClassName('header-mobile');
        if(headerMobile){
          if(headerMobile[0]){
            headerMobile[0].appendChild(mobileHeaderElem);
          }
        }

        //Frosty header desktop
        let desktopHeaderElem = document.createElement('div');
        desktopHeaderElem.setAttribute('class',"holiday-ice");
        let headerDesktop = document.getElementsByClassName('header-desktop');
        if(headerDesktop){
          if(headerDesktop[0]){
            headerDesktop[0].appendChild(desktopHeaderElem);
          }
        }
      }
    }
  }

  public render(): JSX.Element {
    return(
      <div className="holiday-theme-enabled">
        {this.props.snow && <Snow />}
    </div>
    )
  }
}

export default HolidayUi;
